import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AgreementService } from './api/agreement.service';
import { AuthenticationService } from './api/authentication.service';
import { AuthenticationFlowService } from './api/authenticationFlow.service';
import { EmailVerificationService } from './api/emailVerification.service';
import { InvitationService } from './api/invitation.service';
import { PasswordService } from './api/password.service';
import { RecoveryEmailService } from './api/recoveryEmail.service';
import { SessionService } from './api/session.service';
import { TotpService } from './api/totp.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AgreementService,
    AuthenticationService,
    AuthenticationFlowService,
    EmailVerificationService,
    InvitationService,
    PasswordService,
    RecoveryEmailService,
    SessionService,
    TotpService,
    UserService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
